/* eslint-disable prettier/prettier */
import * as React from "react";;
import { useLocation, useHistory } from 'react-router-dom';
import { useFlash } from "../FlashContext";
import { useEffect } from "react";

const GlobalFlashMessage = () => {
  const location = useLocation();
  const history = useHistory();
  const { showToast } = useFlash();

  useEffect(() => {
    if (location.state?.flashMessage) {
      showToast({
        title: "Success",
        type: "success",
        text: location.state.flashMessage,
      });
      history.replace({
        ...location,
        state: { ...location.state, flashMessage: undefined },
      });
    }
  }, [location, history, showToast]);

  return null; 
};

export default GlobalFlashMessage;
